import { render } from "./payWithDeferred.vue?vue&type=template&id=3c068880&ts=true"
import script from "./payWithDeferred.vue?vue&type=script&lang=ts"
export * from "./payWithDeferred.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\projects\\fpbillions\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__